export default {
  zh: {
    title: '任务负责人',
    hint: '请从下表中点击选择任务负责人',
    placeholder: '按照用户名或团队名进行筛选',
    label: '搜索',
  },
  en: {
    title: 'Assignees',
    hint: 'Click the row to choose the assignee',
    placeholder: 'Filter Name/Team in table',
    label: 'Search',
  },
};



// WEBPACK FOOTER //
// ./src/components/ui/AssigneeModal/i18n.js